import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

const BuscadorAlarmasService = async (values) => {
    try {
        const resultado = await instance.Backend.post("/Alarma/BuscadorAlarmas",
            values, customConfig
        );
        return resultado
    } catch (error) {
        console.log(error);
    }
}
export { BuscadorAlarmasService };